import { Component, Inject, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MemberGn1Service} from 'src/app/services/member-gn1.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-gn1-excluded-dialog',
  templateUrl: './member-gn1-excluded-dialog.component.html',
  styleUrls: ['./member-gn1-excluded-dialog.component.scss']
})
export class MemberGn1ExcludedDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public local_title: string;

  constructor(
    public matDialogRef: MatDialogRef<MemberGn1ExcludedDialogComponent>,
    private fb: FormBuilder,
    public _memberGn1Service: MemberGn1Service,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.local_title = this.data.name
   }

  ngOnInit() {
    this._adapter.setLocale('pt');

    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)   

  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.category.setValue(data.category === 'Vazio' ? '' : data.category);
    form.controls.cpf.setValue(data.cpf === 'Vazio' ? '' : data.cpf);
    form.controls.exclude.setValue(data.exclude);
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      category: new FormControl('', [Validators.required]),
      cpf: new FormControl('', [Validators.required]),
      exclude: new FormControl('', [Validators.required])
    });
    return form
  }

}
